import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ScheduleTimesModel} from '../../models/schedule/schedule-times.model';
import {ScheduleTimesDaysConfigurationModel} from '../../models/schedule/schedule-times-days-configuration.model';
import {ScheduleBlockedTimesConfigurationModel} from '../../models/schedule/schedule-blocked-times-configuration.model';

@Injectable({
  providedIn: 'root'
})
export class ScheduleTimeService {
  controller = 'schedule-time';

  constructor(private http: HttpClient) {

  }

  getSchedule(locationId: number) {
    return this.http.get<ScheduleTimesModel>(`api/scheduling-time/get-scheduling-times/${locationId}`);
  }

  saveSchedule(schedule: ScheduleTimesModel) {
    return this.http.post<ScheduleTimesModel>(`api/scheduling-time/save-scheduling-times`, schedule);
  }

  deleteScheduleTimesDay(ScheduleTimeDayID: string) {
    return this.http.delete<any>(`api/scheduling-time/delete-scheduling-times-day/${ScheduleTimeDayID}`);
  }

  deleteScheduleBlockedTimesDay(day: ScheduleBlockedTimesConfigurationModel) {
    return this.http.post<any>(`api/scheduling-time/delete-scheduling-blocked-times-day`, day);
  }
}
